import { Capacitor } from "@capacitor/core";
import { Clipboard } from "@capacitor/clipboard";
import { Share } from "@capacitor/share";

export async function copyPaymentText(value) {
  const text = String(value || "").trim();
  if (!text) return false;
  if (Capacitor.isNativePlatform()) {
    await Clipboard.write({ string: text });
    return true;
  }
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand("copy");
  textarea.remove();
  return copied;
}

export async function sharePixPayment({ pix, amount, driverName }) {
  const code = String(pix || "").trim();
  if (!code) return false;
  const value = Number(amount || 0);
  const text = [
    `Pix da corrida Zuno${driverName ? ` para ${String(driverName).split(" ")[0]}` : ""}.`,
    value > 0 ? `Valor: R$ ${value.toFixed(2)}` : null,
    `Chave ou código Pix: ${code}`,
  ].filter(Boolean).join("\n");
  if (Capacitor.isNativePlatform()) {
    await Share.share({ title: "Pagamento Pix Zuno", text, dialogTitle: "Compartilhar Pix" });
    return true;
  }
  if (navigator.share) {
    await navigator.share({ title: "Pagamento Pix Zuno", text });
    return true;
  }
  return false;
}
